__turbopack_context__.v({
  "accordion": "styles-module-scss-module__p4usCa__accordion",
  "arrowRight": "styles-module-scss-module__p4usCa__arrowRight",
  "bottom": "styles-module-scss-module__p4usCa__bottom",
  "closeModalProduct": "styles-module-scss-module__p4usCa__closeModalProduct",
  "content": "styles-module-scss-module__p4usCa__content",
  "divider": "styles-module-scss-module__p4usCa__divider",
  "faqBottom": "styles-module-scss-module__p4usCa__faqBottom",
  "faqModal": "styles-module-scss-module__p4usCa__faqModal",
  "faqSection": "styles-module-scss-module__p4usCa__faqSection",
  "headerMenu": "styles-module-scss-module__p4usCa__headerMenu",
  "headerNav": "styles-module-scss-module__p4usCa__headerNav",
  "leftTopMobile": "styles-module-scss-module__p4usCa__leftTopMobile",
  "logo": "styles-module-scss-module__p4usCa__logo",
  "mainHeader": "styles-module-scss-module__p4usCa__mainHeader",
  "menuBurguer": "styles-module-scss-module__p4usCa__menuBurguer",
  "menuChild": "styles-module-scss-module__p4usCa__menuChild",
  "menuContent": "styles-module-scss-module__p4usCa__menuContent",
  "menuDrawer": "styles-module-scss-module__p4usCa__menuDrawer",
  "open": "styles-module-scss-module__p4usCa__open",
  "productImage": "styles-module-scss-module__p4usCa__productImage",
  "productInterest": "styles-module-scss-module__p4usCa__productInterest",
  "productItem": "styles-module-scss-module__p4usCa__productItem",
  "productName": "styles-module-scss-module__p4usCa__productName",
  "productPrice": "styles-module-scss-module__p4usCa__productPrice",
  "productSlider": "styles-module-scss-module__p4usCa__productSlider",
  "productsList": "styles-module-scss-module__p4usCa__productsList",
  "searchContent": "styles-module-scss-module__p4usCa__searchContent",
  "searchDrawer": "styles-module-scss-module__p4usCa__searchDrawer",
  "searchInput": "styles-module-scss-module__p4usCa__searchInput",
  "searchTerms": "styles-module-scss-module__p4usCa__searchTerms",
  "slideDown": "styles-module-scss-module__p4usCa__slideDown",
  "sticky": "styles-module-scss-module__p4usCa__sticky",
  "subDrawerContent": "styles-module-scss-module__p4usCa__subDrawerContent",
  "subDrawerHeader": "styles-module-scss-module__p4usCa__subDrawerHeader",
  "subDrawerTitle": "styles-module-scss-module__p4usCa__subDrawerTitle",
  "subMenu": "styles-module-scss-module__p4usCa__subMenu",
  "subMenuMobile": "styles-module-scss-module__p4usCa__subMenuMobile",
  "titleChild": "styles-module-scss-module__p4usCa__titleChild",
  "topBar": "styles-module-scss-module__p4usCa__topBar",
});
